import React from 'react';
import { Layout, Card, Typography, Row, Col, Divider } from 'antd';
import { 
  BulbOutlined,
  EditOutlined,
  CameraOutlined,
  DollarOutlined,
  SwapOutlined,
  CheckCircleOutlined
} from '@ant-design/icons';
import './SellerService.css'; // We'll create this CSS file

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const SellerService = () => {
  const services = [
    {
      icon: <BulbOutlined style={{ fontSize: '24px', color: '#AA5970' }} />,
      title: "1. Consultation: Uncovering the USPs of Your Home",
      content: "We begin with a deep-dive consultation to understand your home's unique selling points (USPs)—from layout efficiencies to renovation quality, orientation, view, and surrounding amenities. I'll help you uncover what makes your home stand out and share how we'll position those advantages to attract the right buyers."
    },
    {
      icon: <EditOutlined style={{ fontSize: '24px', color: '#AA5970' }} />,
      title: "2. Edit: Elevating the Buyer Experience",
      content: "From staging tips to decluttering advice, I'll guide you through simple yet impactful edits that enhance your home's presentation—both in-person and online. Every detail is curated to ensure buyers feel the value the moment they step in."
    },
    {
      icon: <CameraOutlined style={{ fontSize: '24px', color: '#AA5970' }} />,
      title: "3. Post: High-Impact Marketing Execution",
      content: "This is where strategy meets creativity. I'll launch a full-scale, high-impact marketing campaign featuring professional photos, cinematic videos, short-form reels, and targeted ad placements across major property portals and social media. Your listing won't just be seen—it will stand out."
    },
    {
      icon: <DollarOutlined style={{ fontSize: '24px', color: '#AA5970' }} />,
      title: "4. Sale: Negotiation & Closure with Confidence",
      content: "From managing viewings to navigating offers, I'll handle all buyer interactions with a strong, data-backed negotiation approach—ensuring you secure the best price in the shortest time possible. I keep you updated every step of the way and represent your interests fully until the deal is closed."
    },
    {
      icon: <SwapOutlined style={{ fontSize: '24px', color: '#AA5970' }} />,
      title: "5. Next Step Service: Purchase Support at No Cost",
      content: "Planning to upgrade or reinvest after selling? I'll help you transition smoothly into your next property. If you're purchasing a private property, my post-sale advisory and purchase assistance service is completely free of charge—from timeline planning to financial breakdowns and shortlisting the best options."
    }
  ];

  return (
    <Content className = "top-color" style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      <Title level={1} style={{ textAlign: 'center', marginBottom: '24px', color: '#AA5970' }}>
        🔑 Seller's Kit: List Smart. Sell Right.
      </Title>
      
      <Paragraph style={{ 
        fontSize: '1.1rem', 
        textAlign: 'center', 
        maxWidth: '800px', 
        margin: '0 auto 40px',
        color: '#444'
      }}>
        Selling your home isn't just about putting it on the market—it's about crafting the right narrative, 
        positioning it competitively, and guiding you through every step until you're ready for your next move.
      </Paragraph>

      <Divider orientation="left">
        <Text strong style={{ color: '#AA5970', fontSize: '1.2rem' }}>
          Here's how I do it:
        </Text>
      </Divider>

      <Row gutter={[24, 24]} style={{ marginTop: '40px' }}>
  {services.map((service, index) => {
    const isFourth = index === 3;
    return (
      <Col
        key={index}
        xs={24}
        sm={12}
        md={{ span: 8, offset: isFourth ? 3 : 0 }}
      >
        <Card
          className={`buyer-seller-service-card color-strip-${(index % 3) + 1}`}
          hoverable
          style={{
            fontFamily: 'ivypresto, serif',
            color: 'black',
            height: '100%',
            borderRadius: '12px',
          }}
          bodyStyle={{
            padding: '24px',
            fontFamily: 'ivypresto, serif',
            color: 'black',
          }}
        >
          <div className="card-header" style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
            {service.icon}
            <Title
              level={4}
              className="card-title"
              style={{ fontFamily: 'ivypresto, serif', color: 'black', margin: '0 0 0 12px' }}
            >
              {service.title}
            </Title>
          </div>
          <Paragraph
            className="card-description"
            style={{ fontFamily: 'ivypresto, serif', color: 'black' }}
          >
            {service.content}
          </Paragraph>
        </Card>
      </Col>
    );
  })}
</Row>


     
    </Content>
  );
};

export default SellerService;